import $ from "jquery"

$(function() {
    const $desktopmenu = $("#desktopmenu");
    const $ul = $desktopmenu.find("ul.dropdownmenu").first();
    $ul.children("li").slice(-1).find("ul").first().addClass("opens-right"); //slice -1 = last 1. slice -2 = last 2

    //disallow click on menuitems with submenu
    /*
    $desktopmenu.on("click", "li.hassubmenu > a", function(ev) {
        ev.preventDefault();
    });
    */

    function enhanceHtml() {
        $ul.find("li.hassubmenu > a").append('<svg class="icon icon-arrowdown"><use xlink:href="#icon-arrownav"></use></svg>');
    }
    enhanceHtml();

    if($("#kontakt").length == 0) {
        //Kontaktformular ist auf der Seite nicht vorhanden
        //z.B. https://spitexaktiv24.ch/kostenloser-erstbesuch/
        //=> Link in Menü anpassen
        $("#desktopmenu").find(".mi-36 > a").attr("href", "/#kontakt");
    }
});